export default __webpack_public_path__ + "static/media/Group1754.4efd20d2.svg";